<template>
  <div class="generic-radio-list" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
      <div v-for="val in values" :key="val.id" class="form-check">
        <input class="form-check-input" type="radio" :value="`${val.value}`" :id="`radio${val.id}`" v-model="currentValue" :disabled="elementDisabled">
        <label class="form-check-label" :for="`radio${val.id}`">
          {{val.display}}
        </label>
      </div>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'GenericRadioList',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
    }
  },
  computed: {
    values () {
      return this.formField.formListItems
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
